export default __webpack_public_path__ + "static/media/meli-melo.827c72cf.png";